/*
  Wear It With — PDP complementary products panel.

  Each row carries a JSON payload of its colourways (each colourway is its own
  Tuchuzy product, linked via the custom.variants metafield). Selecting a swatch
  swaps the row to that product; selecting a size picks the exact variant; Add
  posts that variant to /cart/add.js and re-renders the mini cart, so the
  customer never leaves the product page.

  Falls back to a normal form post when the cart drawer is disabled or when the
  customer is already on the cart page.
*/
(function () {
  'use strict';

  var ITEM_SELECTOR = '[data-wear-it-with-item]';

  function addUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart_add_url) {
      return window.theme.routes.cart_add_url;
    }
    return '/cart/add';
  }

  function drawerEnabled() {
    return !!(
      window.theme &&
      window.theme.shopSettings &&
      window.theme.shopSettings.cartDrawer
    );
  }

  function WearItWithItem(root) {
    this.root = root;
    this.colours = this.readData();
    if (!this.colours || !this.colours.length) return;

    this.index = 0;
    this.mediaLink = root.querySelector('[data-wear-it-with-media-link]');
    this.image = root.querySelector('[data-wear-it-with-image]');
    this.title = root.querySelector('[data-wear-it-with-title]');
    this.price = root.querySelector('[data-wear-it-with-price]');
    this.select = root.querySelector('[data-wear-it-with-size]');
    this.button = root.querySelector('[data-wear-it-with-add]');
    this.buttonLabel = root.querySelector('[data-wear-it-with-add-label]');
    this.message = root.querySelector('[data-wear-it-with-message]');
    this.swatches = Array.prototype.slice.call(
      root.querySelectorAll('[data-wear-it-with-swatch]')
    );

    this.strings = {
      placeholder: root.dataset.placeholder || 'Select your size',
      soldOutSuffix: root.dataset.soldOutSuffix || 'Sold out',
      add: root.dataset.addLabel || 'Add',
      added: root.dataset.addedLabel || 'Added',
      soldOut: root.dataset.soldOutLabel || 'Sold out',
      selectSize: root.dataset.selectSizeMessage || 'Please select a size'
    };

    this.bind();
    root.setAttribute('data-wear-it-with-ready', 'true');
  }

  WearItWithItem.prototype.readData = function () {
    var script = this.root.querySelector('[data-wear-it-with-data]');
    if (!script) return null;
    try {
      var parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : null;
    } catch (error) {
      return null;
    }
  };

  WearItWithItem.prototype.bind = function () {
    var self = this;

    this.swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var next = parseInt(swatch.getAttribute('data-wear-it-with-swatch'), 10);
        if (isNaN(next) || next === self.index) return;
        self.selectColour(next);
      });

      swatch.addEventListener('keydown', function (event) {
        var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
        if (keys.indexOf(event.key) === -1) return;
        event.preventDefault();
        var step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        var count = self.swatches.length;
        var next = (self.index + step + count) % count;
        self.selectColour(next);
        self.swatches[next].focus();
      });
    });

    if (this.select) {
      this.select.addEventListener('change', function () {
        self.clearMessage();
      });
    }

    if (this.button) {
      this.button.addEventListener('click', function () {
        self.onAdd();
      });
    }
  };

  WearItWithItem.prototype.selectColour = function (index) {
    var colour = this.colours[index];
    if (!colour) return;

    this.index = index;
    this.clearMessage();

    this.swatches.forEach(function (swatch, i) {
      swatch.setAttribute('aria-checked', i === index ? 'true' : 'false');
    });

    if (this.image && this.image.tagName === 'IMG') {
      this.image.setAttribute('src', colour.imgSrc || '');
      this.image.setAttribute('srcset', colour.imgSrcset || '');
      this.image.setAttribute('alt', colour.title || '');
      if (colour.imgWidth) this.image.setAttribute('width', colour.imgWidth);
      if (colour.imgHeight) this.image.setAttribute('height', colour.imgHeight);
    }

    if (this.mediaLink) this.mediaLink.setAttribute('href', colour.url || '#');

    if (this.title) {
      this.title.textContent = colour.title || '';
      this.title.setAttribute('href', colour.url || '#');
    }

    if (this.price) this.price.innerHTML = colour.priceHtml || '';

    this.renderSizes(colour);
  };

  WearItWithItem.prototype.renderSizes = function (colour) {
    if (!this.select) return;

    var sizes = colour.sizes || [];
    var available = sizes.filter(function (size) {
      return size.available;
    });

    this.select.innerHTML = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.textContent = this.strings.placeholder;
    this.select.appendChild(placeholder);

    var suffix = ' — ' + this.strings.soldOutSuffix;
    var self = this;

    sizes.forEach(function (size) {
      var option = document.createElement('option');
      option.value = String(size.id);
      option.textContent = size.available ? size.label : size.label + suffix;
      option.disabled = !size.available;
      self.select.appendChild(option);
    });

    if (available.length === 1) {
      this.select.value = String(available[0].id);
    } else {
      placeholder.selected = true;
      this.select.value = '';
    }

    this.select.disabled = available.length === 0;
    this.setButtonState(available.length > 0);
  };

  WearItWithItem.prototype.setButtonState = function (purchasable) {
    if (!this.button) return;
    this.button.disabled = !purchasable;
    if (this.buttonLabel) {
      this.buttonLabel.textContent = purchasable
        ? this.strings.add
        : this.strings.soldOut;
    }
  };

  WearItWithItem.prototype.showMessage = function (text, isSuccess) {
    if (!this.message) return;
    this.message.textContent = text;
    this.message.classList.toggle('wear-it-with__message--success', !!isSuccess);
    this.message.hidden = false;
  };

  WearItWithItem.prototype.clearMessage = function () {
    if (!this.message) return;
    this.message.hidden = true;
    this.message.textContent = '';
  };

  WearItWithItem.prototype.onAdd = function () {
    if (!this.select || !this.button || this.button.disabled) return;

    var variantId = this.select.value;

    if (!variantId) {
      this.showMessage(this.strings.selectSize, false);
      this.select.focus();
      return;
    }

    var selected = this.select.options[this.select.selectedIndex];
    if (selected && selected.disabled) {
      this.showMessage(this.strings.selectSize, false);
      this.select.focus();
      return;
    }

    this.clearMessage();
    this.addToCart(variantId);
  };

  WearItWithItem.prototype.addToCart = function (variantId) {
    var self = this;
    var cart = document.querySelector('mini-cart');
    var onCartPage = document.body.classList.contains('template-cart');

    // No drawer available — fall back to a standard form post.
    if (!cart || !drawerEnabled() || onCartPage) {
      if (window.Shopify && typeof window.Shopify.postLink === 'function') {
        window.Shopify.postLink(addUrl(), {
          parameters: { id: variantId, quantity: 1 }
        });
      } else {
        window.location.href = '/cart';
      }
      return;
    }

    var sections = [];
    try {
      sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
    } catch (error) {
      sections = [];
    }

    this.button.classList.add('is-loading');
    this.button.setAttribute('aria-disabled', 'true');
    var originalLabel = this.buttonLabel ? this.buttonLabel.textContent : '';

    fetch(addUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          throw new Error(state.description || state.message || 'Unable to add');
        }

        // pubsub.js declares PUB_SUB_EVENTS with `const`, so it lives in script
        // scope and is NOT on window — reference the bare identifier. `typeof`
        // on an undeclared name is safe and does not throw.
        try {
          if (
            typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined'
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'wear-it-with',
              productVariantId: variantId,
              cartData: state
            });
          }
        } catch (pubError) {
          /* broadcasting is best-effort — never block the add */
        }

        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }

        cart.renderContents(state);

        if (self.buttonLabel) self.buttonLabel.textContent = self.strings.added;
        window.setTimeout(function () {
          if (self.buttonLabel) self.buttonLabel.textContent = originalLabel;
        }, 2000);
      })
      .catch(function (error) {
        self.showMessage(error.message || 'Sorry, that could not be added.', false);
        if (self.buttonLabel) self.buttonLabel.textContent = originalLabel;
      })
      .finally(function () {
        self.button.classList.remove('is-loading');
        self.button.removeAttribute('aria-disabled');
      });
  };

  function init(scope) {
    var root = scope || document;
    var items = root.querySelectorAll(ITEM_SELECTOR);
    Array.prototype.forEach.call(items, function (item) {
      if (item.getAttribute('data-wear-it-with-ready') === 'true') return;
      new WearItWithItem(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-initialise after theme-editor section reloads / quick-view injection.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function () {
    init();
  });

  window.wearItWithInit = init;
})();
